module.exports = __webpack_public_path__ + "img/coupon_pc_tab_02.494eefaf.png";